import { render, staticRenderFns } from "./SearchPlaceholder.vue?vue&type=template&id=12b4cfca&scoped=true&"
import script from "./SearchPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./SearchPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./SearchPlaceholder.vue?vue&type=style&index=0&id=12b4cfca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4cfca",
  null
  
)

export default component.exports